export enum PermissionMutationType{
    SET_ROUTES = 'SET_ROUTES',
    SET_ROUTES_BAK = 'SET_ROUTES_BAK',
    SET_WHITE_PATHS = 'SET_WHITE_PATHS',
    SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE'
}
